<template>
  <div id="VehicleComponentGroup" class="q-pa-md">
    <div class="text-h6 q-mx-md q-my-sm">{{ name }}</div>
    <div class="row">
      <div class="col-2 q-ma-sm" v-if="vehicles">
        <q-list class="buttons-list">
          <q-item
            v-for="item in vehicles"
            :key="item"
            clickable
            v-ripple
            :active="vehicle === item"
            @click="changeVehicleComponentSelecet(item)"
            active-class="itemSelect"
            class="item q-pa-md q-ma-sm shadow-1"
          >
            <q-item-section class="ellipsis"> {{ $gettext(item.name) }}</q-item-section>
          </q-item>
        </q-list>
      </div>
      <q-card class="col-9 q-ma-md no-padding">
        <span v-for="item in vehicles" :key="item">
          <q-card-section v-if="vehicle === item" class="padding-crud">
            <crud-layout-search
              :ref="'crudLayoutSearch-' + item.name"
              :name="$gettext(item.name)"
              :interface="item.interface"
              :id="id"
              clean-layout
            />
          </q-card-section>
        </span>
      </q-card>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import { JtCrud } from 'jtech-webcomps'
const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'VehicleComponentGroup',
  components: {
    CrudLayoutSearch
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class VehicleComponentGroup extends Vue {
  vehicles = [];
  vehicle = '';
  indice = 0;

  beforeMount () {
    this.vehicles = [
      {
        name: 'VEHICLE_MODEL',
        interface: 'vehicleModel.pesquisar'
      },
      {
        name: 'VEHICLE_BRAND',
        interface: 'vehicleBrand.pesquisar'
      },
      {
        name: 'VEHICLE_TYPE',
        interface: 'vehicleType.pesquisar'
      }
    ]
    this.vehicle = this.vehicles[0]
  }

  changeVehicleComponentSelecet (item) {
    this.vehicle = item
  }
}
export default VehicleComponentGroup
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

#VehicleComponentGroup {
.buttons-top-crud{
    margin-top: 5px;
    margin-bottom: -3px;
  }

::v-deep {
  .jt-crud-container {
    padding: 0%;
  }
}

.padding-crud{
     padding: 0px 10px 10px;
     margin-top: -15px;
   }

    .itemSelect{
     color: white;
     background: $secondary!important;
     border-left: 5px solid $dark!important;
     padding-left: 5%!imporant;
   }

   .item{
     background: white;
     font-weight: 500;
     padding-left: 10%;
     font-size: 1rem;
   }
 }
</style>
